// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Toast from './../pages/Toast'
import router from '../router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#toast',
  router,
  template: '<Toast/>',
  components: { Toast }
})



// WEBPACK FOOTER //
// ./src/js/toast.js